import React from 'react';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  useAddLeadToList,
  useLeadListsQuery,
  useRemoveLeadFromList,
} from '../hooks/useLeadsQuery';

// "Adicionar à lista" do menu de ações: um checklist das listas do colaborador.
// Marcar adiciona, desmarcar remove — cobre as duas ações com uma entrada só.
const LeadsAddToListDialog = ({ lead, onClose }) => {
  const { t } = useTranslation();
  const { data: lists = [] } = useLeadListsQuery();
  const addMutation = useAddLeadToList();
  const removeMutation = useRemoveLeadFromList();
  const isSaving = addMutation.isPending || removeMutation.isPending;

  const toggle = (list, isMember) => {
    const mutation = isMember ? removeMutation : addMutation;
    mutation.mutate({ listUuid: list.uuid, leadUuid: lead.uuid });
  };

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t('leads.lists.addToList')}</DialogTitle>
      {lists.length === 0 ? (
        <DialogContent>
          <Typography variant="body2" color="text.secondary">
            {t('leads.lists.empty')}
          </Typography>
        </DialogContent>
      ) : (
        <List dense>
          {lists.map((list) => {
            const isMember = list.leads.includes(lead.uuid);
            return (
              <ListItemButton key={list.uuid} disabled={isSaving} onClick={() => toggle(list, isMember)}>
                <ListItemIcon>
                  <Checkbox edge="start" disableRipple tabIndex={-1} checked={isMember} />
                </ListItemIcon>
                <ListItemText primary={list.name} />
              </ListItemButton>
            );
          })}
        </List>
      )}
      <DialogActions>
        <Button onClick={onClose}>{t('leads.lists.done')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeadsAddToListDialog;
